export default __webpack_public_path__ + "star-email.svg";